"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inner = exports.IconMargin = void 0;
var tslib_1 = require("tslib");
var ui_icon_1 = require("@hopin-team/ui-icon");
var ui_spinner_1 = require("@hopin-team/ui-spinner");
var react_1 = tslib_1.__importStar(require("react"));
var decorator_1 = require("../styled/decorator");
var IconMargin;
(function (IconMargin) {
    IconMargin[IconMargin["tiny"] = 1] = "tiny";
    IconMargin[IconMargin["small"] = 2] = "small";
    IconMargin[IconMargin["medium"] = 2] = "medium";
    IconMargin[IconMargin["large"] = 2] = "large";
})(IconMargin = exports.IconMargin || (exports.IconMargin = {}));
var Inner = function (_a) {
    var children = _a.children, isOutlined = _a.isOutlined, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, isLoading = _a.isLoading, pattern = _a.pattern, size = _a.size;
    var spinnerPattern = (0, react_1.useMemo)(function () {
        if ((pattern === 'inverse' && isOutlined) ||
            (pattern === 'danger' && !isOutlined)) {
            return 'inverse';
        }
        if (pattern === 'primary') {
            return 'primary';
        }
        else
            return 'secondary';
    }, [pattern, isOutlined]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(decorator_1.Decorator, null, leadingIcon && (react_1.default.createElement(ui_icon_1.Icon, { name: leadingIcon, "aria-hidden": true, mr: 2, isParentColor: true }))),
        isLoading && (react_1.default.createElement(ui_spinner_1.Spinner, { isShowing: true, isPolite: true, size: size === 'tiny' ? 'small' : 'medium', pattern: spinnerPattern })),
        !isLoading && children,
        react_1.default.createElement(decorator_1.Decorator, null, trailingIcon && (react_1.default.createElement(ui_icon_1.Icon, { name: trailingIcon, "aria-hidden": true, ml: 2, isParentColor: true })))));
};
exports.Inner = Inner;
//# sourceMappingURL=inner.js.map